import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { IndianRupee, Wallet, TrendingUp, BedDouble } from "lucide-react";
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid } from "recharts";

export default function OwnerEarnings() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/owner/earnings").then((r) => setData(r.data)); }, []);
  if (!data) return null;

  const chartData = data.monthly.map((m) => ({
    month: m.month,
    "You earn": Math.round(m.net),
    "Platform fee": Math.round(m.fee),
  }));

  const stats = [
    { icon: Wallet, label: "You've earned (net)", value: `₹${Math.round(data.total_net_to_owner).toLocaleString("en-IN")}`, cls: "bg-emerald-100 text-emerald-700" },
    { icon: TrendingUp, label: "Gross collected", value: `₹${Math.round(data.total_gross).toLocaleString("en-IN")}`, cls: "bg-orange-100 text-orange-800" },
    { icon: IndianRupee, label: "Platform fee (historic — now ₹0)", value: `₹${Math.round(data.total_platform_fee).toLocaleString("en-IN")}`, cls: "bg-amber-100 text-amber-800" },
    { icon: BedDouble, label: "Bed-nights sold", value: data.total_bed_nights, cls: "bg-stone-900 text-white" },
  ];

  return (
    <section className="mb-10">
      <div className="flex items-baseline justify-between mb-5">
        <div>
          <div className="text-xs tracking-[0.25em] uppercase font-bold text-amber-600">Earnings</div>
          <h2 className="font-display font-black text-3xl tracking-tighter mt-1">Your income at a glance</h2>
        </div>
        <div className="text-xs text-slate-500">Updated live · {data.total_bookings} paid booking(s)</div>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        {stats.map((s) => (
          <div key={s.label} data-testid={`earn-stat-${s.label}`} className="bg-white border border-slate-200 rounded-2xl p-5">
            <div className={`w-10 h-10 rounded-xl grid place-items-center ${s.cls}`}><s.icon size={18} /></div>
            <div className="mt-4 text-[10px] tracking-widest uppercase font-bold text-slate-500">{s.label}</div>
            <div className="font-display font-black text-2xl mt-1">{s.value}</div>
          </div>
        ))}
      </div>

      {chartData.length > 0 && (
        <div className="mt-6 bg-white border border-slate-200 rounded-2xl p-6">
          <div className="text-xs tracking-widest uppercase font-bold text-slate-500 mb-4">Monthly breakdown</div>
          <div className="h-64">
            <ResponsiveContainer width="100%" height="100%">
              <BarChart data={chartData}>
                <CartesianGrid strokeDasharray="3 3" stroke="#e2e8f0" />
                <XAxis dataKey="month" stroke="#64748b" fontSize={12} />
                <YAxis stroke="#64748b" fontSize={12} />
                <Tooltip contentStyle={{ borderRadius: 12, border: "1px solid #e2e8f0" }} formatter={(v) => `₹${v.toLocaleString("en-IN")}`} />
                <Bar dataKey="You earn" fill="#4338CA" radius={[6, 6, 0, 0]} />
                <Bar dataKey="Platform fee" fill="#FF6B35" radius={[6, 6, 0, 0]} />
              </BarChart>
            </ResponsiveContainer>
          </div>
        </div>
      )}
    </section>
  );
}
